<template>
    <div ref="rootEl">
        <slot></slot>
    </div>
</template>

<script>
import {MDCSelect} from '@material/select';
import {MDCTextField} from '@material/textfield';
import {ref,onMounted} from "vue";

export default {
    name: "mdc-form",
    setup() {
        const rootEl = ref();
        const selects = ref([]);
        const textfields = ref([]);

        onMounted(() => {
            selects.value = [].map.call(rootEl.value.querySelectorAll('.mdc-select'), function(el) {
                return new MDCSelect(el);
            });
            textfields.value = [].map.call(rootEl.value.querySelectorAll('.mdc-text-field'), function(el) {
                return new MDCTextField(el);
            })
        })

        return {
            rootEl
        };
    }
}
</script>

<style scoped>

</style>
